import React from 'react';
import { View } from 'react-native';

interface SimpleAudioVisualizerProps {
  isRecording?: boolean;
}

const SimpleAudioVisualizer: React.FC<SimpleAudioVisualizerProps> = ({ isRecording = false }) => {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        height: 20,
      }}
    >
      {[...Array(5)].map((_, index) => (
        <View
          key={index}
          style={{
            width: 3,
            height: isRecording ? Math.random() * 20 : 4,
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            borderRadius: 2,
            transition: 'height 0.1s ease',
          }}
        />
      ))}
    </View>
  );
};

export default SimpleAudioVisualizer;
